import { Group, Mesh } from '@anov/3d-core'
import type { SceneControl } from '@anov/3d-core'
import { EWeatherType } from '../../utils/type'
import { Rain_Icon, Snow_Icon } from '../../utils/constant'
import PlaneMesh from './plane'
import PointMesh from './point'
import type LineMesh from './lineRain'

class RainMesh extends Mesh {
  plane: PlaneMesh
  point: PointMesh
  lineMesh: LineMesh
  group: Group
  option

  constructor(option: { width: number;height: number;segment: number }, sceneControl: SceneControl) {
    super()
    this.option = option
    this.group = new Group()
    this.plane = new PlaneMesh(option, sceneControl)
    // this.lineMesh = new LineMesh(option)
    this.point = new PointMesh(undefined, sceneControl)

    this.initialize()
  }

  initialize() {
    this.group.add(this.plane)
    // this.group.add(this.lineMesh)
    this.group.add(this.point)
    this.add(this.group)
  }

  /**
   * 设置云效果
   * @param {string} type - 效果类型
   * @param {ICloudOption} ops - 配置参数
   */
  setEffect(type: string) {
    const { width } = this.option
    const calculateSize = (size) => {
      return width * size / 2000
    }

    const planeEffects = {
      [EWeatherType.Rain]: { size: calculateSize(20), snowT1density: 0.0, rainT1density: 0.2, snowSpeed: 0.3, rainSpeed: 0.25 },
      [EWeatherType.Rain_Thunderstorm]: { size: calculateSize(30), snowT1density: 0.0, rainT1density: 0.3, snowSpeed: 0.6, rainSpeed: 0.31 },
      [EWeatherType.Snow]: { size: calculateSize(50), snowT1density: 0.2, rainT1density: 0, snowSpeed: 0.8 },
      [EWeatherType.Snow_Blizzard]: { size: calculateSize(40), snowT1density: 0.3, rainT1density: 0, snowSpeed: 0.6 },
    }
    const pointEffects = {
      [EWeatherType.Rain]: { speed: [0, 2, 0], range: width, size: 0.5, icon: Rain_Icon, count: 0 }, // width * 500
      [EWeatherType.Rain_Thunderstorm]: { speed: [0, 3, 0], size: 0.5, range: width, icon: Rain_Icon, count: 0 }, // width * 2200
      [EWeatherType.Snow]: { speed: [0, 1.5, 0], size: 4, range: width, icon: Snow_Icon, count: width * 20 },
      [EWeatherType.Snow_Blizzard]: { speed: [0, 2, 0], size: 5, range: width, icon: Snow_Icon, count: width * 40 },
    }
    this.plane.setEffect(planeEffects[type])
    // this.lineMesh.setEffect(planeEffects[type])
    this.point.setEffect(pointEffects[type])
  }

  update() {
    this.plane.update()
    // this.lineMesh.update()
    this.point.update()
  }

  delete() {
    this.group.remove(this.plane)
    // this.group.remove(this.lineMesh)
    this.group.remove(this.point)
    this.remove(this.group)
    this.removeFromParent()
  }
}

export default RainMesh
